<template>

  <v-container fluid class="pt-2 order-receiver-info" v-if="order">

    <!-- Title: Shipping To -->
    <v-row class="pa-0 ma-0">
      <v-col cols="12" class="d-flex align-center">
        <!-- <v-icon color="white" class="mr-1">mdi-map-marker-outline</v-icon> -->
        <span class="title">{{ title }}</span>
      </v-col>
    </v-row>

    <!-- Location name -->
    <v-row class="pa-0 ma-0 mt-2 d-flex align-center">
      <v-col cols="12" xs="12" sm="3" md="2" lg="2">
        <div class="attr-label">Location:</div>
      </v-col>
      <v-col cols="12" xs="12" sm="9" md="10" lg="10">
        <router-link :to="generateReceiverPageLink()">
          <span class="location-name">{{ receiver.name }}</span>
        </router-link>
      </v-col>
    </v-row>

    <!-- Address -->
    <v-row class="pa-0 ma-0 mt-2">
      <v-col cols="12" xs="12" sm="3" md="2" lg="2" class="d-flex align-start">
        <div class="attr-label">Address:</div>
      </v-col>
      <v-col cols="12" xs="12" sm="9" md="10" lg="10">
        <div>{{ receiverMultilineAddress.street_1 }}</div>
        <div v-if="receiverMultilineAddress.street_2">{{ receiverMultilineAddress.street_2 }}</div>
        <div v-if="receiverMultilineAddress.area">{{ receiverMultilineAddress.area }}</div>
      </v-col>
    </v-row>

    <!-- Phone -->
    <v-row class="pa-0 ma-0 d-flex align-center">
      <v-col cols="12" xs="12" sm="3" md="2" lg="2">
        <div class="attr-label">Phone:</div>
      </v-col>
      <v-col cols="12" xs="12" sm="9" md="10" lg="10">
        <div>{{ receiver.phone }}</div>
      </v-col>
    </v-row>

    <!-- Primary email -->
    <v-row class="pa-0 ma-0 d-flex align-center" v-if="showEmail">
      <v-col cols="12" xs="12" sm="3" md="2" lg="2">
        <div class="attr-label">Email:</div>
      </v-col>
      <v-col cols="12" xs="12" sm="9" md="10" lg="10">
        <div v-if="receiverPrimaryEmail">{{ receiverPrimaryEmail.email }}</div>
      </v-col>
    </v-row>

  </v-container>

</template>

<script>

export default {
  name: 'OrderReceiverInfo',

  data () {
    return {
      showEmail: false,
      receiverEmails: null
    }
  },

  props: {
    order: {
      type: Object,
      required: true
    },
    title: {
      type: String,
      default: 'Shipping To'
    }
  },

  computed: {
    // -------------------- receiver info
    receiver () {
      return this.order.receiver || {}
    },
    receiverMultilineAddress () {
      return this.$root.utils.getAddressTextFromData(this.receiver, { multi_lines: true })
    },
    receiverPrimaryEmail () {
      return (this.receiverEmails)
        ? this.receiverEmails.find(email => email.is_primary === true)
        : null
    }
  },

  async beforeMount () {
    this.loadRecipientEmails()
  },

  methods: {
    generateReceiverPageLink () {
      return {
        name: 'receiver-item',
        params: { receiverId: this.receiver.id }
      }
    },

    // Load associated recipient emails
    async loadRecipientEmails () {
      // Load for receiver
      if (this.receiver.id) {
        try {
          const collection = await this.$store.dispatch('sh/dataApi', {
            method: 'get',
            uri: 'recipientEmails',
            opts: {
              params: { location_id: this.receiver.id }
            }
          })
          this.receiverEmails = collection.items
        } catch (err) {
          console.log('Error loading recipient emails for receiver =>', err)
        }
      } // end-if (this.receiver.id)
    }
  }
}
</script>

<style scoped>
  .order-receiver-info .location-name {
    font-size: 1.14rem;
  }

  .order-receiver-info a {
    text-decoration: none;
  }
  .order-receiver-info a:hover {
    text-decoration: underline;
  }
</style>
